import { render, staticRenderFns } from "./ModalDeleteImage.vue?vue&type=template&id=4bb87eb1&scoped=true&"
import script from "./ModalDeleteImage.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteImage.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeleteImage.vue?vue&type=style&index=0&id=4bb87eb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb87eb1",
  null
  
)

export default component.exports